'use strict';

const btnBackToTop = document.querySelector('.button__container--right');
const header = document.querySelector('.shopify-section-group-header-group');


const collectionGrid = document.querySelector('.facets-vertical.page-width');
collectionGrid.addEventListener('click', function(e) {
  if (!e.target.classList.contains('update-image')) return;
  const btn = e.target.closest('button');
  btn.closest('.grid__item').querySelector('.media img').src = btn.dataset['image'];
  btn.closest('.card__information').querySelector('.full-unstyled-link').href = btn.dataset['link'];
})

btnBackToTop.addEventListener('click', function(e) {
    header.scrollIntoView({behavior: 'smooth'})
})